// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListC_TheComp__bLjNd"};